import axios from '@/plugins/axios';

export default {
  /**
   * Obtiene los participantes de una conferencia
   * @param {number} conferenceId - ID de la conferencia
   * @returns {Promise} - Promise con la lista de participantes
   */
  getConferenceParticipants(conferenceId) {
    return axios.get(`/conferences/${conferenceId}/participants`);
  },


  exportConferenceParticipants(conferenceId) {
    return axios.get(`/conferences/${conferenceId}/export-conference-participants`, {
      responseType: 'blob',
      headers: {
        'Accept': 'text/csv'
      }
    });
  },

  getByConvention(conventionId) {
    return axios.get(`/conventions/${conventionId}/conferences`);
  },

  /**
   * Obtiene todas las salas disponibles
   * @returns {Promise} - Promise con la lista de salas
   */
  getRooms() {
    return axios.get('/conferences/rooms');
  },

  /**
   * Marca la asistencia de un participante a una conferencia
   * @param {number} conferenceId - ID de la conferencia
   * @param {number} participantId - ID del participante
   * @param {boolean} attended - Si el participante asistió o no
   * @returns {Promise} - Promise con la respuesta
   */
  markAttendance(conferenceId, participantId, attended) {
    return axios.post(`/conferences/${conferenceId}/attendance`, {
      participant_id: participantId,
      attended: attended
    });
  },

  /**
   * Obtiene las estadísticas de asistencia de una conferencia
   * @param {number} conferenceId - ID de la conferencia
   * @returns {Promise} - Promise con las estadísticas
   */
  getAttendanceStats(conferenceId) {
    return axios.get(`/conferences/${conferenceId}/attendance-stats`);
  },

  /**
   * Actualiza la asistencia de múltiples participantes
   * @param {number} conferenceId - ID de la conferencia
   * @param {Array} attendanceData - Array de objetos con participant_id y attended
   * @returns {Promise} - Promise con la respuesta
   */
  updateMultipleAttendance(conferenceId, attendanceData) {
    return axios.put(`/conferences/${conferenceId}/attendance`, {
      attendance: attendanceData
    });
  },
};